import Vue from 'vue'
import Vuex from 'vuex'

import Partners from './imports/Partners'
import HeaderLinks from './imports/HeaderLinks'
import HeaderContent from './imports/HeaderContent'
import IntroText from './imports/IntroText'
import Products from './imports/Products'
import Press from './imports/Press'
import Careers from './imports/Careers'
import Contact from './imports/Contact'
import Security from './imports/Security'
import AttachProducts from './imports/AttachProducts'
import StudiosProducts from './imports/StudiosProducts'
import SolutionsAndIndustries from './imports/SolutionsAndIndustries'
import VerticalPageData from './imports/VerticalPageData'
import AttachFamilyList from './imports/AttachFamilyList'
import Whitepaper from './imports/Whitepaper'

Vue.use(Vuex)

const state = {
  headerLinks: HeaderLinks.links,
  introText: IntroText.text,
  headerText: HeaderContent.text,
  subheaderText: HeaderContent.subheaderText,
  promoText: HeaderContent.promoText,
  partnerText: Partners.partnerText,
  partnerList: Partners.partnerList,
  keyPartnerList: Partners.keyPartnerList,
  productList: Products.list,
  pressContent: Press.content,
  contactContent: Contact,
  careersContent: Careers,
  attachProducts: AttachProducts,
  studiosProducts: StudiosProducts,
  solutionsAndIndustries: SolutionsAndIndustries,
  verticalPageData: VerticalPageData,
  attachFamilyList: AttachFamilyList,
  security: Security,
  Whitepaper: Whitepaper,
  cartList: []
}

const mutations = {
  setCartList(state, carts) {
    state.cartList = carts
  }
}

const actions = {}

const store = new Vuex.Store({
  state,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./client/store/index.js